<script lang="ts" setup>
import { useI18n } from 'vue-i18n'

import { BlockContainer, AffiliateDisclaimer } from '@toni/brand-ui'

const { t } = useI18n()
</script>

<template>
  <BlockContainer>
    <AffiliateDisclaimer>
      <template #trigger>
        {{ t('affiliateDisclaimer.trigger') }}
      </template>
      <template #content>
        {{ t('affiliateDisclaimer.content') }}
      </template>
    </AffiliateDisclaimer>
  </BlockContainer>
</template>
